// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1nB-vAkW_nN3PvTUGwZX0Z","title":"_2seyJDACo805XVnJBXxrSY","content":"fmuAUMIeqSp70KfU40Qxt"};